'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Chip = require('material-ui/Chip');

var _Chip2 = _interopRequireDefault(_Chip);

var _Form = require('material-ui/Form');

var _Input = require('material-ui/Input');

var _EntoroMultiSelect = require('./EntoroMultiSelect');

var _EntoroMultiSelect2 = _interopRequireDefault(_EntoroMultiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiSelect = function MultiSelect(_ref) {
  var input = _ref.input,
      formLabel = _ref.label,
      options = _ref.options,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      groups = _ref.groups,
      required = _ref.required,
      helperText = _ref.helperText,
      getUniqueLabel = _ref.getUniqueLabel,
      reverseDropDown = _ref.reverseDropDown;
  return _react2.default.createElement(
    _Form.FormControl,
    { fullWidth: true },
    _react2.default.createElement(
      _Input.InputLabel,
      {
        style: input.value.length ? {} : { lineHeight: 2.6 },
        shrink: input.value.length ? true : undefined,
        required: required,
        error: Boolean(touched && error)
      },
      formLabel
    ),
    _react2.default.createElement(_EntoroMultiSelect2.default, {
      options: options,
      groups: groups,
      onChange: input.onChange,
      values: input.value || [],
      theme: 'material',
      style: { width: '100%', marginTop: '16px' },
      renderValue: function renderValue(_ref2, onRemoveByValue) {
        var label = _ref2.label;
        return _react2.default.createElement(_Chip2.default, {
          label: label,
          onDelete: onRemoveByValue
        });
      },
      getUniqueLabel: getUniqueLabel,
      reverseDropDown: reverseDropDown
    }),
    (helperText || touched && error) && _react2.default.createElement(
      _Form.FormHelperText,
      {
        error: Boolean(touched && error)
      },
      touched && error ? error : helperText
    )
  );
};

MultiSelect.propTypes = {
  input: _propTypes2.default.object.isRequired,
  label: _propTypes2.default.node.isRequired,
  options: _propTypes2.default.array.isRequired,
  meta: _propTypes2.default.object.isRequired,
  groups: _propTypes2.default.array,
  required: _propTypes2.default.bool,
  helperText: _propTypes2.default.string,
  getUniqueLabel: _propTypes2.default.func,
  reverseDropDown: _propTypes2.default.bool
};

MultiSelect.defaultProps = {
  groups: [],
  required: false,
  helperText: null,
  getUniqueLabel: undefined,
  reverseDropDown: false
};

exports.default = MultiSelect;